import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const LockIcon: React.FC<NormalIconProps> = (props) => (
	<svg className={props.className} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#clip0_207_5271)">
			<path
				d="M1 8C1 6.58579 1 5.87868 1.43934 5.43934C1.87868 5 2.58579 5 4 5H8C9.41421 5 10.1213 5 10.5607 5.43934C11 5.87868 11 6.58579 11 8C11 9.41421 11 10.1213 10.5607 10.5607C10.1213 11 9.41421 11 8 11H4C2.58579 11 1.87868 11 1.43934 10.5607C1 10.1213 1 9.41421 1 8Z"
				stroke=""
				stroke-width="1.5"
			/>
			<path d="M3 5V4C3 2.34315 4.34315 1 6 1C7.65685 1 9 2.34315 9 4V5" stroke="" stroke-width="1.5" stroke-linecap="round" />
		</g>
		<defs>
			<clipPath id="clip0_207_5271">
				<rect width="12" height="12" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
